import Axios from "axios";
import { configuraciones, creditos } from "../../components/generico/utils/UrlAPI";

import authService from "../login/auth.service";

class ConfigService {

    obtenerSucursalesCercanas(localizacion) {

        localizacion = {
            latitud: localizacion && localizacion[0],
            longitud: localizacion && localizacion[1]
        }

        var config = {
            method: "get",
            params: localizacion,
            url: configuraciones + "ubicacion/sucursal",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken()
            }
        };
        return Axios(config);
    }

    ocultarSegunNombre(name) {
        //si no se encuentra el path, ocultar
        return this.getPathByName(name) === null
            ? { display: "none" }
            : null;
    }
    ocultarAlias(name) {
        //si no se encuentra el path, ocultar
        return this.getPathByName(name) === null
            ? { display: "none" }
            : null;
    }

    getAccesoById(id) {
        let acceso = this.getAccesos()?.find(acceso => acceso.id === id);
        return acceso ? acceso : null;
    }

    findAccesoById = (id, array = this.getAccesos()) => {
        for (let i = 0; i < array.length; i++) {
            let value = array[i];
            if (value.id === id) return value;
            if (value.children !== null) {
                let acceso = this.findAccesoById(id, value.children);
                if (acceso !== null) return acceso;
            }
        }

        return null;
    };

    getPathByName(name) {
        let path = this.getPaths()?.find(path => path.nombre === name);

        if (name === "resumenGeneralSocio" && !path) return { url: "/home" }

        //si no encuentra, retorna null
        return path
            ? path
            : null;
    }

    getPathById(id) {

        let path = this.getPaths()?.find(path => path.id === id);
        //si no encuentra, retorna null
        return path ? path : null;

    }

    getFirstChildByName(name) {

        let parent = this.getPathByName(name);

        let child = this.getPaths()?.find(path => path.idPadre === parent?.id);

        return child ? child : null;

    }

    getPreviousPathByName(name) {

        //si no hay paths
        if (this.getPaths() === null) return null;

        let actualPath = this.getPathByName(name);

        let previousPath = null;

        if (actualPath === null) return null;

        /**
         * buscar el path anterior al actual
         * debe ser del mismo padre, con el valor de orden anterior al actual
         * y no debe controlar el mismo path
         */
        this.getPaths().forEach((path) => {

            if (path.nombre !== actualPath.nombre && path.idPadre === actualPath.idPadre && path.orden < actualPath.orden) {
                previousPath = path;
                return;
            }
        });

        return previousPath ? previousPath : null;

    }

    getAccesos() {

        let storage = sessionStorage.getItem("menu");
        if (storage) return JSON.parse(storage).accesos;
        return null
        //return accesos;
    }

    getPaths() {

        let storage = sessionStorage.getItem("menu");
        if (storage) return JSON.parse(storage).paths;
        return null
        //return paths;
    }

    async getAccess(token) {
        var config = {
            method: "get",
            url: configuraciones + "menu/WEB",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        return Axios(config);

    }


    async agendamientoAsamblea(tieneDosisCompleta) {

        var config = {
            method: "POST",
            url: configuraciones + `asamblea/agendamiento?tieneDosisCompleta=${tieneDosisCompleta}&canal=WEB`,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken()
            }
        };
        return await Axios(config);
    }

    async obtenerAviso() {
        var config = {
            method: "GET",
            url: configuraciones + `aviso/`,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken()
            }
        };
        return await Axios(config);
    }

}

export default new ConfigService();
